module.exports = __webpack_public_path__ + "static/media/iguazu-falls-24.d721fea2.jpg";